import { render, staticRenderFns } from "./koulutussopimus.vue?vue&type=template&id=bf5a8d9e&scoped=true&"
import script from "./koulutussopimus.vue?vue&type=script&lang=ts&"
export * from "./koulutussopimus.vue?vue&type=script&lang=ts&"
import style0 from "./koulutussopimus.vue?vue&type=style&index=0&id=bf5a8d9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5a8d9e",
  null
  
)

export default component.exports